import React from 'react';

import { Flag } from '../Flag';

export interface ObjectCardFlagsProps {
  flags?: string[];
}

export const ObjectCardFlags: React.FC<ObjectCardFlagsProps> = ({ flags }) => {
  if (flags === undefined || !Array.isArray(flags)) {
    return <></>;
  }

  const getFlags = () => {
    if (flags) {
      return flags.map((flag: string, i: number) => {
        if (i < 2) {
          return <Flag key={i} flag={flag} width={18} />;
        } else {
          if (flags.length > 3) {
            if (i === 2) {
              return <>...</>;
            } else {
              return <></>;
            }
          } else {
            return <Flag key={i} flag={flag} width={18} />;
          }
        }
      });
    } else {
      return <></>;
    }
  };

  return <div style={{ display: 'flex' }}>{getFlags()}</div>;
};
